<template>
  <div class="main_footer">
    <div class="footer">
      <div class="box">
        <div class="logo">
          <img src="../assets/img/yuanjie-logo1.png" alt="" />
        </div>
        <div class="item" v-for="(item, index) in footerList" :key="index">
          <h3>{{ $parseLabel(item.title) }}</h3>
          <div class="ibox">
            <div v-for="subItem in item.itemList" :key="subItem.id">
              <a v-if="subItem.type === 'link' && subItem.id === 2001" href="javascript:void(0)" @click="open(subItem)">{{
                $parseLabel(subItem.title)
              }}</a>
              <a v-else-if="subItem.type === 'link' && subItem.id === 2002" href="javascript:void(0)" @click="open(subItem)">{{
                $parseLabel(subItem.title)
              }}</a>
              <a v-else-if="subItem.type === 'link' && subItem.id === 2003" href="javascript:void(0)" @click="open(subItem)">{{
                $parseLabel(subItem.title)
              }}</a>
              <a v-else-if="subItem.type === 'link' && subItem.id === 1003" href="javascript:void(0)" @click="open(subItem)">{{
                $parseLabel(subItem.title)
              }}</a>
              <a v-else-if="subItem.type === 'link'" :href="subItem.url" target="_blank">{{
                $parseLabel(subItem.title)
              }}</a>
              <el-popover
                v-else-if="subItem.type === 'img'"
                class="popover"
                placement="right"
                width="150"
                height="150"
                trigger="hover">
                <img style="width: 150px; height: 150px;" src="../assets/img/wechat.jpg" alt="" />
                <span  slot="reference">{{ $parseLabel(subItem.title) }}</span>
              </el-popover>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="copyright">
      <span>Copyright ©2024 上海元杰智能科技有限公司 版权所有</span>
      <a href="https://beian.miit.gov.cn/" target="_blank" rel="noopener noreferrer" class="beian-link">{{ beianNumber }}</a>
    </div>
  </div>
</template>
      
<script>
import { Footer } from "../utils/data";
const BEIAN_BY_HOST = {
  "www.yjdemo.cloud": "沪ICP备2021035316号-12",
  "www.yuanjietech.cloud": "沪ICP备2021035316号-7"
};

export default {
  data() {
    return {
      footerList: Footer
    };
  },
  computed: {
    beianNumber() {
      return BEIAN_BY_HOST[window.location.hostname] || "沪ICP备2021035316号-12";
    }
  },
  methods: {
    open(subItem) {
      if(subItem.id === 2001) {
        if((this.isEmpty(this.$store.state.userData.name) === false)
          ||(this.isEmpty(this.$store.state.userData.email) === false)) {
            window.open(subItem.url)
        } else {
          this.$encryption(subItem.url, 'home');
        }
      } else if(subItem.id === 2002) {
        if((this.isEmpty(this.$store.state.userData.name) === false)
          ||(this.isEmpty(this.$store.state.userData.email) === false)) {
            window.open(subItem.url)
        } else {
          this.$encryption(subItem.url, 'home');
        }
      } else if(subItem.id === 2003) {
        if((this.isEmpty(this.$store.state.userData.name) === false)
          ||(this.isEmpty(this.$store.state.userData.email) === false)) {
          //跳转到登录页
          this.$redirectToLogin();
        } else {
          window.open(subItem.url + "&email=" + this.$store.state.userData.email + "&nickname=" + this.$store.state.userData.name)
        }
      } else if(subItem.id === 1003) {
        window.open('javascript:window.name;', '<script>location.replace("' + subItem.url + '")<\/script>');
      }
    }
  }
};
</script>
      
<style lang="less" scoped>
.main_footer {
  min-width: 1500px;
}

.footer {
  width: 100%;
  height: 200px;
  margin: 0px;
  background: var(--footerBgColor);
  .box {
    width: 85%;
    height: 100%;
    margin: auto;
    display: flex;

    .logo {
      width: 25%;
      height: 100%;
      display: flex;
      align-items: center;
      margin-right: 50px;
      img {
        width: 250px;
      }
    }
    .item {
      width: 13%;
      display: flex;
      flex-direction: column;
      justify-content: center;
      h3 {
        height: 50px;
        line-height: 50px;
        color: #fff;
        font-size: 17px;
        margin-top: 30px;
      }
      .ibox {
        height: 100%;
        display: flex;
        flex-direction: column;

        a {
          text-decoration: none;
          color: #fff;
          margin-bottom: 8px;
          font-size: 13px;
        }

        p {
          text-decoration: none;
          color: #fff;
          margin-bottom: 8px;
          font-size: 13px;
        }

        .popover {
          span {
          text-decoration: none;
          color: #fff;
          margin-bottom: 8px;
          font-size: 13px;
        }
        }
      }
    }
  }
}
.copyright {
    width: 100%;
    height: 40px;
    line-height: 40px;
    font-size: 12px;
    color: #fff;
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 16px;
    background: var(--footerBgColor);

    .beian-link {
      color: #fff;
      text-decoration: none;

      &:hover {
        text-decoration: underline;
      }
    }
}
</style>